module.exports = __webpack_public_path__ + "img/Skirt-Front-B4-Da-Fc-Gc-Hc-Ib-Jb.71baf07b.png";